<template>
  <ChargingInfo
    v-if="wiredChargerMinWatts && wiredChargerMaxWatts"
    :charger-included="chargerIncluded"
    :wired-charger-min-watts="wiredChargerMinWatts"
    :wired-charger-max-watts="wiredChargerMaxWatts"
    :usb-pd-supported="usbPdSupported"
  />
</template>

<script lang="ts" setup>
import { ChargingInfo } from '#components';
const store = useMyProductPageStore();

const chargerIncluded =
  computed(() =>
    store.product?.Specifications?.find(
      (spec: { Name: string; Value: string }) =>
        spec.Name === 'EU-Laddare[1]:Laddningsenhet medföljer',
    ),
  ).value?.Value === 'Ja';

const wiredChargerMinWatts =
  computed(() =>
    store.product?.Specifications?.find(
      (spec: { Name: string; Value: string }) =>
        spec.Name === 'EU-Laddare[2]:Laddeffekt min. i Watt',
    ),
  ).value?.Value || '';

const wiredChargerMaxWatts =
  computed(() =>
    store.product?.Specifications?.find(
      (spec: { Name: string; Value: string }) =>
        spec.Name === 'EU-Laddare[3]:Laddeffekt max. i Watt',
    ),
  ).value?.Value || '';

const usbPdSupported =
  computed(() =>
    store.product?.Specifications?.find(
      (spec: { Name: string; Value: string }) =>
        spec.Name === 'EU-Laddare[4]:USB-strömförsörjning (USB PD)',
    ),
  ).value?.Value === 'Ja';
</script>

<style lang="scss" scoped></style>
